<template>
    <div style='display:flex;'>
        <div class='bar' :class="{'unselected' : !selected}"></div>
        <div class='item-container' :class="{'selected': selected == true}">
            <div class='inner-item'>
                <div class='icon-container'><span :class="icon"></span></div>
                <div v-show='expanded'>{{text}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['text', 'icon', 'url', 'selected', 'id', 'expanded'],
    watch:{
        'selected': function(){
            if(this.id == this.selected){

            }
        }
    }
}
</script>

<style scoped>
.item-container{
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 0.9rem;
    cursor: pointer;
    padding: 13px 10px;
    flex-grow: 1;
    color: #385170;
    
}
.icon-container{
    width: 20px;
    font-size: 1.2rem;
}

.item-container.selected{
    background-color: #7380ec40;
    /* color: var(--primary-variant-1); */
    color: #385170;
    box-sizing: border-box;
    border-radius: 3px;
}
.inner-item{
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0px 10px;
}

.bar{
    width: 6px;
    border-radius: 2px;
    background-color: var(--primary-colour);
}

.bar.unselected{
    background-color: transparent;
}
</style>